/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { useThemeClassName } from '../../../contexts/ThemeContext';
import CheckIcon from '../../icons/Check';
import DefaultBonusCard from './DefaultBonusCard';

import styles from '../../../../styles/items/bonus-card-participations.module.scss';

const propTypes = {
    count: PropTypes.number.isRequired,
    progress: PropTypes.number.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function ParticipationsBonusCard({ className, progress, count, ...props }) {
    const themeClassName = useThemeClassName(styles);
    const progressIndex = progress * count;
    return (
        <DefaultBonusCard
            className={classNames([styles.container, themeClassName, className])}
            {...props}
        >
            <div className={styles.progress}>
                {[...Array(count).keys()].map((index) => (
                    <div
                        key={`card-${index + 1}`}
                        className={classNames([
                            styles.participation,
                            {
                                [styles.done]: index < progressIndex,
                            },
                        ])}
                    >
                        {index < progressIndex ? (
                            <CheckIcon className={styles.check} />
                        ) : (
                            <span className={styles.label}>{`${index + 1}`}</span>
                        )}
                    </div>
                ))}
            </div>
        </DefaultBonusCard>
    );
}

ParticipationsBonusCard.propTypes = propTypes;
ParticipationsBonusCard.defaultProps = defaultProps;

export default ParticipationsBonusCard;
